import { setupWorker } from "msw";
import athenaHandlers from "./handlers/athena.handlers";
import jiraHandlers from "./handlers/jira.handlers";

const handlers = [...jiraHandlers, ...athenaHandlers];

// This configures a Service Worker with the given request handlers.

export const worker = setupWorker(...handlers);
